export const APP = 'movies-vector';
export const CRED = '824f623279eb:692cfeef-621b-4495-872f-ad3e01757909';
export const INDEX_CRED = 'ec5fba278186:12029f20-aa7a-41a5-b102-acfea4dfa830';
export const URL = 'https://opensearch-demo-knn-1-drhnehb-arc.searchbase.io';
export const TYPE = '_doc';
